import React from "react";
import styled, { useTheme } from "styled-components";
import { isEmpty } from "lodash";
import { LoadingSpinner, SpinnerSize } from "../../LoadingSpinner";
import { DashboardItem } from "../DashboardItem/DashboardItem";
import { DEFAULT_EMPTY_TEXT } from "../constants";
function renderKpiItem(item, idx) {
    const { label, value } = item;
    return (React.createElement(KpiWrapper, { "data-testid": "kpiItem", key: idx },
        React.createElement(KpiLabel, { "data-testid": "KpiItemLabel" }, label),
        React.createElement(KpiValue, { "data-testid": "KpiItemValue" }, value)));
}
const KpiWrapper = styled.div `
  width: 100%;
  display: flex;
  font-weight: 300;
  margin-bottom: ${(props) => `${props.theme.space[3]}px`};
`;
const KpiLabel = styled.p `
  flex: 1;
  margin: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
`;
const KpiValue = styled.p `
  flex: 1;
  margin: 0;
  text-align: right;
  white-space: nowrap;
`;
export const MultiKpi = (props) => {
    const theme = useTheme();
    const { title, data, rowSpan, columnSpan, emptyText = DEFAULT_EMPTY_TEXT, isLoading = false } = props;
    return (React.createElement(Wrapper, { "data-testid": "MultiKpi", rowSpan: rowSpan, columnSpan: columnSpan },
        React.createElement(Content, null,
            title && React.createElement(Heading, { "data-testid": "MultiKpiTitle" }, title),
            isLoading && React.createElement(LoadingSpinner, { size: SpinnerSize.SMALL }),
            !isEmpty(data) && !isLoading && data.map(renderKpiItem),
            !isLoading && isEmpty(data) && (React.createElement(React.Fragment, null,
                React.createElement(EmptyIcon, { "data-testid": "MultiKpiEmptyIcon", src: theme.svg.emptyStateSvg, alt: "Empty icon", role: "img" }),
                React.createElement(EmptyText, { "data-testid": "MultiKpiEmptyMessage" }, emptyText))))));
};
const Wrapper = styled(DashboardItem) `
  padding: 24px;
  text-align: center;
`;
const Content = styled.div `
  height: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;
const Heading = styled.h4 `
  margin: 0;
  font-size: ${(props) => `${props.theme.fontSizes[1]}px`};
  font-weight: 300;
  margin-bottom: ${(props) => `${props.theme.space[4]}px`};
`;
const EmptyIcon = styled.img `
  width: 120px;
  height: 83px;
  padding-bottom: 12px;
`;
const EmptyText = styled.p `
  color: ${(props) => props.theme.colors.dashboardColors.multiKpiEmptyText};
  margin: 0;
`;
